//@ts-ignore
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import { SocialResponse } from '../common/interfaces/user';
import { appConfig } from '../../utils/appConfig';
import useTechnicalErrorMessage from '../common/hooks/useTechnicalErrorMessage';
import * as Sentry from '@sentry/react';

interface SignInFacebookProps {
	facebookSignIn: any;
}

const SignInFacebook = ({ facebookSignIn }: SignInFacebookProps) => {
	const [showTechnicalErrorMessage] = useTechnicalErrorMessage();

	const facebookResponseSuccess = async (response: any) => {
		if (response) {
			const facebookResponse: SocialResponse = {
				firstName: response.first_name,
				lastName: response.last_name,
				email: response.email,
				token: response.accessToken,
				type: 'facebook'
			};

			facebookSignIn(facebookResponse);
		}
	};

	const facebookResponseFailure = (response: any) => {
		if (response.status !== 'unknown') {
			Sentry.captureException(new Error(`facebookResponseFailure: ${response}`));
			showTechnicalErrorMessage();
		}
	};

	return (
		<FacebookLogin
			appId={appConfig.facebookClientId}
			autoLoad={false}
			fields="first_name, last_name, name,email,picture"
			callback={facebookResponseSuccess}
			onFailure={facebookResponseFailure}
			disableMobileRedirect={true}
			render={(renderProps: any) => {
				return (
					<button
						className="btn-social facebook-btn"
						aria-label="Sign in with Facebook opens in new window"
						onClick={renderProps.onClick}>
						<img
							src="./images/buttons-social-facebook.png"
							className="icon-social"
							alt="Facebook login"
						/>
					</button>
				);
			}}
		/>
	);
};

export default SignInFacebook;
